// extracted by mini-css-extract-plugin
export default {"button":"BackButton_button__G-mlq","icon":"BackButton_icon__Kprgu"};